import bHODLContract from './bHODL.json';
import USDCContract from './USDC.json';
import DOBContract from './DOB.json';
import uHODLContract from './uHODL.json';
import WBTCContract from './WBTC.json';
import SilverGeregeContract from './SilverGerege.json';
import WETHContract from './WETH.json';
import AuctionContract from './Auction.json';
import bHODLRewarderContract from './bHODLRewarder.json';
import DistributionsContract from './Distributions.json';
import DOBStakingPoolContract from './DOBStakingPool.json';
import GoldGeregeContract from './GoldGerege.json';
import HODLStakingPoolRewarderContract from './HODLStakingPoolRewarder.json';
import HODLStakingPoolsContract from './HODLStakingPools.json';
import OptionFactoryContract from './OptionFactory.json';
import StakingPoolRewarderContract from './StakingPoolRewarder.json';
import StakingPoolsContract from './StakingPools.json';
import uHODLRewarderContract from './uHODLRewarder.json';
import MatchingMarketContract from './MatchingMarket.json';
export const SilverGeregeAddressETHMainnet = SilverGeregeContract.address;
export const bHODLAddressETHMainnet = bHODLContract.address;
export const USDCAddressETHMainnet = USDCContract.address;
export const DOBAddressETHMainnet = DOBContract.address;
export const uHODLAddressETHMainnet = uHODLContract.address;
export const WETHAddressETHMainnet = WETHContract.address;
export const WBTCAddressETHMainnet = WBTCContract.address;
export const AuctionAddressETHMainnet = AuctionContract.address;
export const bHODLRewarderAddressETHMainnet = bHODLRewarderContract.address;
export const DistributionsAddressETHMainnet = DistributionsContract.address;
export const DOBStakingPoolAddressETHMainnet = DOBStakingPoolContract.address;
export const GoldGeregeAddressETHMainnet = GoldGeregeContract.address;
export const HODLStakingPoolRewarderAddressETHMainnet = HODLStakingPoolRewarderContract.address;
export const HODLStakingPoolsAddressETHMainnet = HODLStakingPoolsContract.address;
export const OptionFactoryAddressETHMainnet = OptionFactoryContract.address;
export const StakingPoolRewarderAddressETHMainnet = StakingPoolRewarderContract.address;
export const StakingPoolsAddressETHMainnet = StakingPoolsContract.address;
export const uHODLRewarderAddressETHMainnet = uHODLRewarderContract.address;
export const MatchingMarketAddressETHMainnet = MatchingMarketContract.address;
export const UniswapV3FactoryAddressETHMainnet = '0x1F98431c8aD98523631AE4a59f267346ea31F984';
//# sourceMappingURL=index.js.map